import { SectionGrant } from 'components/functional'
import { useQuery } from '../useQuery'
import { SHIPMENT_CSV } from 'constants/path'
import MenuItem from '../MenuItem'
import { canShowSidebar } from 'policies/ShipmentCsvPolicy'

type Props = ReturnType<typeof useQuery>

export const ShipmentCsvItem: React.FC<Props> = ({ viewer }) => {
  return (
    <SectionGrant authorized={canShowSidebar(viewer)}>
      <MenuItem href={SHIPMENT_CSV}>一括発送</MenuItem>
    </SectionGrant>
  )
}
